import { DropzoneDragProps } from '../Dropzone.types';

const DropzoneDrag = (props: DropzoneDragProps) => {
  return (
    <div {...props} />
  );
};

export default DropzoneDrag;
